<template>

    <m-edit1/>

    <m-factor-1 v-bind='{...{},...{}}' :style='""' class="my-5 container" >
                <template #default>Mixitweb.com   </template>
                </m-factor-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor1 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor1';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
